import ConnectAPI from "../../../services/api";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import { Col, Container, Row } from "react-bootstrap";
import { Select, TextBox, Table, DatePicker, TextArea, Button, IconPlus, IconListView, IconTrash, Checkbox } from '@veneer/core';

function NewSpecialConditionsProcess(){
    const connectApi = new ConnectAPI();
    const { t } = useTranslation();
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    //const [isLoading, setIsLoading] = useState(false);

    const [category, setCategory] = useState([])
    const [channelList, setChannelList] = useState([])
    const [viewChannel, setViewChannel] = useState(false)
    const [channel, setChannel] = useState("")
    const [endUserList, setEndUserList] = useState([])
    const [endUser, setEndUser] = useState("")
    const [serieFix, setSerieFix] = useState("")
    const [seriesList, setSeriesList] = useState([])
    const [selectedPress, setSelectedPress] = useState(false)
    const [series, setSeries] = useState("")
    const [pressListBySeries, setPressListBySeries] = useState ([])
    const [pressListBySeriesFilter, setPressListBySeriesFilter] = useState ([])
    const [specialConditionTypeList, setSpecialConditionTypeList] = useState ([])
    const [specialConditionType, setSpecialConditionType] = useState("")
    const [segment, setSegment] = useState([])
    const [segmentFlag, setSegmentFlag] = useState(false)
    const [startDate, setStartDate] = useState("")
    const [opdNumber, setOpdNumber] = useState("")
    const [effectiveMonths, setEffectiveMonths] = useState(1)
    const [details, setDetails] = useState("")
    const [objetive, setObjetive] = useState("")
    const [justification, setJustification] = useState("")
    const [competition, setCompetition] = useState("")
    const [resultFuture, setResultFuture] = useState("")
    const [volumeGrowth, setvolumeGrowth] = useState(0)
    const [comments, setComments] = useState("")
    const [endUserContactName, setEndUserContactName] = useState("")
    const [endUserContactPhone, setEndUserContactPhone] = useState("")
    const [endUserContactPosition, setEndUserContactPosition] = useState("")
    const [endUserEmail, setEndUserEmail] = useState("")

    const resetDefaul = () => {
        setCategory([]);
        setChannel("");
        setEndUserList([]);
        setEndUser("");
        setSerieFix("");
        setSeriesList([]);
        setSelectedPress(false);
        setSeries("");
        setPressListBySeries([]);
        setPressListBySeriesFilter([]);
        setSpecialConditionTypeList([]);
        setSpecialConditionType("");
        setSegment([]);
        setStartDate("");
        setOpdNumber("")
        setEffectiveMonths(1);
        setDetails("");
        setObjetive("");
        setJustification("");
        setCompetition("");
        setResultFuture("");
        setvolumeGrowth(0);
        setComments("");
        setEndUserContactName("");
        setEndUserContactPhone("");
        setEndUserContactPosition("");
        setEndUserEmail("");
    }

    useEffect(() => {
        //validate location
        /*let validate = false;
        currentUser.urls.forEach( ur => {
            if ( ur == window.location.pathname ) validate=true;
        });
        if (validate==false){
            const { history } = props;
            history.push({ pathname: '/' });
        }//end validate*/

        console.log("-------------------------currentUser------------------------")
        //currentUser.idCustomer = "CL0047";
        console.log(currentUser)
        console.log(currentUser.idCustomer)
        setEndUserContactName(currentUser.name);
        setEndUserContactPosition(currentUser.jobPosition);
        setEndUserEmail(currentUser.email);

        const fetchData = () => {
            connectApi.get( "api/Channels", "", ChannelListData ).catch(
                (error) => {
                    Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
                }
            );
        };
        const ChannelListData = (status, data) => {
            const items = data.map((item) => {
                if (item.type != "Inactive")
                    return{ value: item.idCustomer, label: item.name };
            });
            let channels = items.filter(x => x)
            if (currentUser.idCustomer == "HP")
                setChannelList(channels);
            else {
                let channelSelect = channels.filter(x => x.value == currentUser.idCustomer);
                setChannelList(channelSelect);
                setChannel([channelSelect[0].value]);
                fetchEndUsers(currentUser.idCustomer);
                setViewChannel(true);
            }
        };

        fetchData();
    }, []);

    const EndUserListData = (status, data) => {
        const items = data.map((item) => {
            return{ value: item.idEndUser, label: item.endUserName };
        });
        setEndUserList(items);
    };
    const fetchEndUsers = (channel) => {
        connectApi.get( "api/Channels/endUsers", {
            params:{ customerId: channel, status: "Active" }
        }, EndUserListData )
        .catch( (error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };
    useEffect(() => { setPressListBySeriesFilter(pressListBySeries.filter((item) => item.series == series && item.segment == segment)); }, [series]);
    const PressListData = (status, data) => {
        setPressListBySeries(data);
        for (let i = 0; i < data.length; i++){
            Object.assign(data[i],{uid:i, rowConfig:{ selected:false }}); 
        }
        if (data.length > 0){
            let array = data.map(x => x.segment).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => x );
            if(array.length == 1){
                setSegment(array);
                setSegmentFlag(true);
            } else {
                setSegment([]);
                setSegmentFlag(false);
            }
            let array2 = data.map(x => x.series).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => {return{ value: x, label: x } });
            setSeriesList(array2)
            if(array2.length == 1){
                setSerieFix([array2[0].value]);
                if(array2[0].value >= 3 && array.length == 1)
                    fetchSpConditions(array2[0].value);
            } else
                setSeries("");
        } else
            setSeriesList([]);
    };
    let xUser = "";
    const fetchPress = (endUser) => {
        xUser=endUser;
        connectApi.get("api/Channels/endUsers/" + endUser + "/ActivePresses",
        { params:{ endUserId: endUser } }, PressListData).catch((error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };
    const SpConditionListData = (status, data) => {
        const items = data.map((item) => {
            return{ value: item.idSpecialConditionType, label: item.specialConditionType };
        });
        if(items.length == 1)
            setSpecialConditionType([items[0].value])
        setSpecialConditionTypeList(items);
    };
    const fetchSpConditions = (serie) => {
        let interUser = endUser[0];
        if(endUser[0]==undefined || endUser[0]=="" )
            interUser = xUser;
        setSeries([serie]);
        connectApi.get("api/Channels/SpConditionType", { params:{ series: serie, idenduser: interUser } }, SpConditionListData)
        .catch((error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };

    function selectionState(dataArray) {
        const total = dataArray.length;
        const selected = dataArray.filter((row) => row.rowConfig.selected).length;
        switch (selected) {
            case 0: return 'none';
            case total: return 'all';
            default: return 'indeterminated';
        }
    }
    function setSegmentFind(segment){
        setSegment([segment]); 

        if(serieFix!="")
            fetchSpConditions(serieFix);

        let array = pressListBySeries.filter((item) => item.segment == segment).map(x => x.series).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => {return{ value: x, label: x } });
        setSeriesList(array)
        
        if(array.length == 1)
            fetchSpConditions(array[0].value);
        else 
            setSeries("");
    }

    /* Metodos para guardar las condiciones especiales. */
    const [oneShotDisabled, setOneShotDisabled] = useState(false)
    const [whiteDisabled, setWhiteDisabled] = useState(false)
    const [segmentSelected, setSegmentSelected] = useState("")
    const [multiplierConfig, setMultiplierConfig] = useState(1)

    // These hooks may be used either for Max Cost Per Print or Bonus Table
    const [isLastTier, setIsLastTier] = useState(false)
    const [minPrint, setMinPrint] = useState(1)
    const [maxPrint, setMaxPrint] = useState("")

    // Max Cost per Impression
    const [blackCpp, setBlackCpp] = useState("")
    const [otherCpp, setOtherCpp] = useState("")
    const [oneShotCpp, setOneShotCpp] = useState("")
    const [whiteCpp, setWhiteCpp] = useState("")
    const [compensationTable, setCompensationTable] = useState([])
    const [lowCoverage, setLowCoverage] = useState(false)

    const showMaxCostPerImpression = () => {
        const handleClick = () => {
            let obj = [...compensationTable];
            if (maxPrint == ""){
                alert(t('alertMaxCost1'))
            } else if (maxPrint < minPrint) {
                alert(t('alertMaxCost2') + (minPrint) + ".")
            } else if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) ){
                alert(t('alertMaxCost3'))
            } else {
                obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                setMinPrint(maxPrint+1);
                setMaxPrint("");
                setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                setCompensationTable(obj);
            }
        };

        const handleLast = () => {
            let obj = [...compensationTable];
            if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) )
                alert(t('alertMaxCost3'))
            else {
                if(!(specialConditionType == 13))
                    obj.push({"minPrint":minPrint,"maxPrint":999999999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                else
                    obj.push({"minPrint":minPrint,"maxPrint":999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                setMinPrint(1);
                setMaxPrint("");
                setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                setCompensationTable(obj);
                setIsLastTier(true);
            }
        };

        if (specialConditionType == 1 || specialConditionType == 13 || specialConditionType == 22  || specialConditionType == 23 || specialConditionType==26){
            return(
                <>
                {(seriesList.find(e=>e.globalaccount===true) && [26,22].includes(specialConditionType))?(<></>):(<>
                    <br />
                    <Row>
                        <br />
                        <Col md="12">
                            <h4 style={{marginLeft:"35%"}}> {t('bonus')} Maximum CPP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            {specialConditionType == 13?(<>
                            <TextBox
                                id="min-print"
                                label="Min LS Mark"
                                maxLength="3"
                                value={minPrint}
                                disabled
                            /><br />
                            <TextBox
                                id="max-print"
                                label="Max LS Mark"
                                maxLength="3"
                                value={maxPrint}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                disabled={isLastTier}
                            /><br />
                            </>):(<>
                            <TextBox
                                id="min-print"
                                label={t('bonustable.table1')}
                                maxLength="9"
                                value={minPrint}
                                disabled
                            /><br />
                            <TextBox
                                id="max-print"
                                label={t('bonustable.table2')}
                                maxLength="9"
                                value={maxPrint}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                disabled={isLastTier}
                            /><br />
                            </>)}
                            <TextBox
                                id="black-cpp"
                                label={t('prices.blackcommprice')}
                                maxLength="10"
                                value={blackCpp}
                                onChange={(e) => { if(!isNaN(e)) setBlackCpp(e); }}
                                disabled={isLastTier}
                            /><br />
                            <TextBox
                                id="other-cpp"
                                label={t('prices.othercommprice')}
                                maxLength="10"
                                value={otherCpp}
                                onChange={(e) => { if(!isNaN(e)) setOtherCpp(e); }}
                                disabled={isLastTier}
                            /><br />
                            <TextBox
                                id="one-shot-cpp"
                                label={t('prices.oneshotcommprice')}
                                maxLength="10"
                                value={oneShotCpp}
                                onChange={(e) => { if(!isNaN(e)) setOneShotCpp(e); }}
                                disabled={isLastTier?true:oneShotDisabled?true:false}
                            /><br />
                            <TextBox
                                id="white-cpp"
                                label={t('prices.whitecommprice')}
                                maxLength="10"
                                value={whiteCpp}
                                onChange={(e) => { if(!isNaN(e)) setWhiteCpp(e); }}
                                disabled={isLastTier?true:whiteDisabled?true:false}
                            /><br />
                            <Button
                                id="add-to-compensation-array"
                                onClick={handleClick}
                                leadingIcon={<IconPlus />}
                                disabled={isLastTier}
                            >
                                {t('addTier')}
                            </Button>
                            <Button
                                id="last-compensation-array"
                                style={{ marginLeft:"15px" }}
                                onClick={handleLast}
                                leadingIcon={<IconListView />}
                                disabled={isLastTier}
                            >
                                {t('lastTier')}
                            </Button><br />
                            <Button
                                id="clear-compensation-array"
                                appearance="secondary"
                                style={{ marginTop:"15px" }}
                                leadingIcon={<IconTrash />}
                                onClick={() => {
                                    setCompensationTable([]);
                                    setMinPrint(1);
                                    setMaxPrint("");
                                    setBlackCpp("");
                                    setOtherCpp("");
                                    setOneShotCpp("");
                                    setWhiteCpp("");
                                    setIsLastTier(false);
                                }}
                            >
                                {t('clearTable')}
                            </Button><br /><br />
                        </Col>
                        <Col xs="8" md="8">
                        <Table
                            name="bonus-table"
                            columns={[
                                {
                                    id: "minPrint",
                                    label: specialConditionType == 13?("Min LS Mark %"):(t('bonustable.table1'))
                                },
                                {
                                    id: "maxPrint",
                                    label: specialConditionType == 13?("Max LS Mark %"):(t('bonustable.table2'))
                                },
                                {
                                    id: "blackCpp",
                                    label: t('prices.blackcommprice')
                                },
                                {
                                    id: "otherCpp",
                                    label: t('prices.othercommprice')
                                },
                                {
                                    id: "oneShotCpp",
                                    label: t('prices.oneshotcommprice')
                                },
                                {
                                    id: "whiteCpp",
                                    label: t('prices.whitecommprice')
                                }
                            ]}
                            data={compensationTable} />
                            <br />
                            <p>{t('memoMaxCost1')}
                                <ul style={{marginLeft:"40px"}}>
                                    <li><u>Indigo 1x000</u>: B2 (A3 <b>x 2</b>)</li>
                                    <li><u>Indigo 20000</u>: B1 (A3 <b>x 4</b>)</li>
                                    <li><u>Indigo 30000</u>: B2 (A3 <b>x 2</b>)</li>
                                </ul>
                            </p><br />
                            <p>{t('memoMaxCost2')}
                            <ul style={{marginLeft:"40px"}}>
                                <li><u>Indigo 1x000</u>: {t('memoMaxCost3')}</li>
                                <li><u>Indigo 20000 &amp; 30000</u>: {t('memoMaxCost4')}</li>
                            </ul>
                            </p>
                        </Col>
                    </Row>
                </>)}
                
                {specialConditionType == 23?(<>
                <Checkbox
                    id = "id-low-coverage-box"
                    label = {t('credit') + " / " + t('debit') + " LSMark?"}
                    checked = {lowCoverage}
                    onChange = {(e) => {
                        setLowCoverage(e.target.checked);
                        setBonusLSDiscount([]);
                        setBonusLSDiscountSend([]);
                        setMinPrintLS(1);
                        setMaxPrintLS("");
                        setBonusLS("");
                        setIsLastTierLS(false);
                        setIsAddOneMin(false);
                    }}
                />
                <br />
                </>):((specialConditionType==26?(<>
                    <Row>
                        <Col xs="4">
                            <TextBox
                                id="minimum-impressions"
                                label={"LSMark Minimum"}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />  
                            {(seriesList.find(e=>e.globalaccount===true))?(
                                <>{t("notelifespandgateg")}</>
                            ):(<>{t("notelifespandgate")}</>)}
                        </Col>
                        <Col xs="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                    </Row>
                    
                </>):("")))}
                </>
            );
        } else {
            return null;
        };
    };

    // Bonus LSDisconunt Table
    const [bonusLSDiscount, setBonusLSDiscount] = useState([])
    const [bonusLSDiscountSend, setBonusLSDiscountSend] = useState([])
    const [bonusLS, setBonusLS] = useState("")
    const [minPrintLS, setMinPrintLS] = useState(1)
    const [maxPrintLS, setMaxPrintLS] = useState("")
    const [isAddOneMin, setIsAddOneMin] = useState(false)
    const [isLastTierLS, setIsLastTierLS] = useState(false)

    const showBonusLSDiscount = () => {
        const handleClick = () => {
            let obj = [...bonusLSDiscount];
            let objSend = [...bonusLSDiscountSend];
            if (maxPrintLS < 0 || isNaN(maxPrintLS) 
                || minPrintLS < 0 || isNaN(minPrintLS)){
                alert(t('alertMaxCost1'))
            } else if (maxPrintLS < minPrintLS) {
                alert(t('alertMaxCost2'))
            } else if (isNaN(bonusLS)) {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrintLS,"maxPrint":maxPrintLS, "bonus":`${(bonusLS)} %`});
                setMinPrintLS(parseInt(maxPrintLS)+1);
                setMaxPrintLS("");
                setBonusLS("");
                setBonusLSDiscount(obj);
                objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":maxPrintLS, "Discount":bonusLS});
                setBonusLSDiscountSend(objSend);
                setIsAddOneMin(true);
            }
        };

        const handleLast = () => {
            let obj = [...bonusLSDiscount];
            let objSend = [...bonusLSDiscountSend];
            if (isNaN(bonusLS) || bonusLS == "") {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrintLS,"maxPrint":9999, "bonus":`${(bonusLS)} %`});
                setMinPrintLS("");
                setMaxPrintLS("");
                setBonusLS("");
                setBonusLSDiscount(obj);
                objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":9999, "Discount":bonusLS});
                setBonusLSDiscountSend(objSend);
                setIsLastTierLS(true);
            }
        };

        if (specialConditionType == 22  || (specialConditionType == 23 && lowCoverage)){
            return(
                <Row>
                    <br />
                    <Col md="12">
                        <h4 style={{marginLeft:"35%"}}> {t('bonus')} LSMark </h4>
                    </Col>
                    <br />
                    <Col xs="4" md="4">
                        <TextBox
                            id="min-print"
                            label={t("InitialLSMark")}
                            maxLength="4"
                            value={minPrintLS}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e == "") setMinPrintLS(""); else setMinPrintLS(parseInt(e)); }}
                            disabled={isLastTierLS?true:isAddOneMin}
                        /><br />
                        <TextBox
                            id="max-print"
                            label={t("EndLSMark")}
                            maxLength="4"
                            value={maxPrintLS}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e=="") setMaxPrintLS(""); else setMaxPrintLS(parseInt(e)); }}
                            disabled={isLastTierLS}
                        /><br />
                        <TextBox
                            id="bonus"
                            label={t('bonus') + " %"}
                            maxLength="5"
                            value={bonusLS}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setBonusLS(e); }}
                            disabled={isLastTierLS}
                        /><br />
                        <Button
                            id="add-to-bonus-array"
                            onClick={handleClick}
                            leadingIcon={<IconPlus />}
                            disabled={isLastTierLS}
                        >
                            {t('addTier')}
                        </Button>
                        <Button
                            id="last-bonus-array"
                            style={{ marginLeft:"15px" }}
                            onClick={handleLast}
                            leadingIcon={<IconListView />}
                            disabled={isLastTierLS}
                        >
                            {t('lastTier')}
                        </Button><br />
                        <Button
                            id="clear-bonus-array"
                            appearance="secondary"
                            style={{ marginTop:"15px" }}
                            leadingIcon={<IconTrash />}
                            onClick={() => {
                                setBonusLSDiscount([]);
                                setBonusLSDiscountSend([]);
                                setMinPrintLS(1);
                                setMaxPrintLS("");
                                setBonusLS("");
                                setIsLastTierLS(false);
                                setIsAddOneMin(false);
                            }}
                        >
                            {t('clearTable')}
                        </Button><br /><br />
                    </Col>
                    <Col xs="8" md="8">
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "minPrint",
                                label: t("InitialLSMark")
                            },
                            {
                                id: "maxPrint",
                                label: t("EndLSMark")
                            },
                            {
                                id: "bonus",
                                label: t('bonus'),
                            }
                        ]}
                        data={bonusLSDiscount} />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    // Bonus Special Table    
    const [bonusTable, setBonusTable] = useState([])
    const [bonus, setBonus] = useState("")

    const showBonusSpecialTable = () => {
        const handleClick = () => {
            let obj = [...bonusTable];
            if (maxPrint < 0 || isNaN(maxPrint)){
                alert(t('alertMaxCost1'))
            } else if (maxPrint < minPrint) {
                alert(t('alertMaxCost2'))
            } else if (bonus < 0 || isNaN(bonus)) {
                alert(t('alertBonus'))
            } else {
                obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"bonus":bonus});
                setMinPrint(maxPrint+1);
                setMaxPrint("");
                setBonus("");
                setBonusTable(obj);
            }
        };

        const handleLast = () => {
            let obj = [...bonusTable];
            if (!Math.sign(bonus) || bonus == "") {
                alert(t('alertBonus'))
            }
            else {
                obj.push({"minPrint":minPrint,"maxPrint":999999999,"bonus":bonus});
                setMinPrint("");
                setMaxPrint("");
                setBonus("");
                setBonusTable(obj);
                setIsLastTier(true);
            }
        };

        if (specialConditionType == 2 || specialConditionType == 8 || specialConditionType == 12 || specialConditionType == 15 || specialConditionType == 17){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox
                            id="min-print"
                            label={t('bonustable.table1')}
                            maxLength="9"
                            value={minPrint}
                            disabled
                        /><br />
                        <TextBox
                            id="max-print"
                            label={t('bonustable.table2')}
                            maxLength="9"
                            value={maxPrint}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if (e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                            disabled={isLastTier}
                            
                        /><br />
                        <TextBox
                            id="bonus"
                            label="Bonus %"
                            maxLength="3"
                            value={bonus}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setBonus(e); }}
                            disabled={isLastTier}
                        /><br />
                        <Button
                            id="add-to-bonus-array"
                            onClick={handleClick}
                            leadingIcon={<IconPlus />}
                            disabled={isLastTier}
                        >
                            {t('addTier')}
                        </Button>
                        <Button
                            id="last-bonus-array"
                            style={{ marginLeft:"15px" }}
                            onClick={handleLast}
                            leadingIcon={<IconListView />}
                            disabled={isLastTier}
                        >
                            {t('lastTier')}
                        </Button><br />
                        <Button
                            id="clear-bonus-array"
                            appearance="secondary"
                            style={{ marginTop:"15px" }}
                            leadingIcon={<IconTrash />}
                            onClick={() => {
                                setBonusTable([]);
                                setMinPrint(1);
                                setMaxPrint("");
                                setBonus("");
                                setIsLastTier(false);
                            }}
                        >
                            {t('clearTable')}
                        </Button><br /><br />
                    </Col>
                    <Col xs="8" md="8">
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "minPrint",
                                label: t('bonustable.table1')
                            },
                            {
                                id: "maxPrint",
                                label: t('bonustable.table2')
                            },
                            {
                                id: "bonus",
                                label: "Bonus",
                            }
                        ]}
                        data={bonusTable} />
                    </Col>
                    <Col xs="4" md="4">
                        <br />
                        <Checkbox
                            id="epm-bonus-table"
                            label="EPM"
                            onChange={(e) => {
                                if (specialConditionType == 2) {
                                    setSpecialConditionType(12);
                                } else if (specialConditionType == 8) { 
                                    setSpecialConditionType(17);
                                } else {
                                    setSpecialConditionType(0);
                                }
                            }}
                        />
                        <br />
                        <Checkbox
                            id="combine-clicks-fixed-bonus"
                            label="Combine Clicks with other client"
                            onChange={(e) => {
                                if (specialConditionType == 2) {
                                    setSpecialConditionType(8);
                                } else if (specialConditionType == 12) { 
                                    setSpecialConditionType(17);
                                } else {
                                    setSpecialConditionType(0);
                                }
                            }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    // Fixed Bonus
    const [percentage, setPercentage] = useState("")
    const [minimumImp, setMinimumImp] = useState(0)

    const showFixedBonus = () => {
        if (specialConditionType == 3 || specialConditionType == 14 || specialConditionType == 23 || specialConditionType==25){
            return(
                <Row>
                    {( specialConditionType==3 || specialConditionType==14 ) ? (<>
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus"
                                label="Fixed Bonus %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e); }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions"
                                label={t('bonustable.table1')}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <Checkbox
                                id="epm-fixed-bonus"
                                name="epm-fixed-bonus"
                                label="EPM"
                                onChange={(e) => {
                                    if (specialConditionType == 3) {
                                        setSpecialConditionType(14);
                                    }
                                    else {
                                        setSpecialConditionType(3);
                                    }
                                }}
                            />
                        </Col>
                    </>):(
                    (specialConditionType==23)?(//type 23: Low Coverage Program
                    <>
                        <br />
                        <Col md="12">
                            <h4> {t('bonus')} LCP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions2"
                                label="Coverage Below %"
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                    </>):(<>
                        <br />
                        <Col md="12">
                            <h4> {t('bonus')} FWP </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions2"
                                label="Coverage Below (mm)"
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                    </>)
                    )}
                    <br /> <br />
                </Row>
            );
        } else if(specialConditionType==27) {
            connectApi
            .getWithParams("api/Channels/getClickTiers",
            {
                idcustomer: channel[0],
                idenduser:endUser[0],
                idpress: seriesList[0].idPress
                
            }).catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                    );
            });
        }else {
            return null;
        };
    };

    // Tiers Up
    const showTiersUp = () => {
        if (specialConditionType == 4 || specialConditionType == 19){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <Select
                            id="tiers-up"
                            label="Tiers Up %"
                            value={[percentage]}
                            options={[ 
                                { value: 5, label: '1 Tier Up - 5%' },
                                { value: 10, label: '2 Tiers Up - 10%' },
                                { value: 15, label: '3 Tiers Up - 15%' }
                                ]}
                            onChange={(e) => {
                                setPercentage(e.value);
                            }}
                            onClear={() =>{
                                setPercentage();
                            }}
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-impressions"
                            label={t('bonustable.table1')}
                            maxLength="9"
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    // Run Length
    const [MinimumPrint, setMinimumPrint]=useState(0);

    const showRunLength = () => {
        if ( specialConditionType === 21 ){
            let segmentCompare = segmentSelected;
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox 
                            label="Minimum Print" 
                            value={MinimumPrint}
                            maxLength="9"
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setMinimumPrint(e); }} 
                        />
                    </Col>
                    {segmentCompare == "L&P"?(
                    <Col xs="4" md="4">
                        <Select
                            id="minimun_metters"
                            label={t('minimumMetters')+" L&P*"}
                            value={minimumImp===0?'':[minimumImp]}
                            options={[ 
                                { value: 2000, label: t('minimumMetters')+' - 2,000' },
                                { value: 3000, label: t('minimumMetters')+' - 3,000' },
                                { value: 3500, label: t('minimumMetters')+' - 3,500' },
                                { value: 5000, label: t('minimumMetters')+' - 5,000' },
                                { value: 7500, label: t('minimumMetters')+' - 7,500' },
                                { value: 10000, label: t('minimumMetters')+' - 10,000' },
                                { value: 12500, label: t('minimumMetters')+' - 12,500' },
                                { value: 15000, label: t('minimumMetters')+' - 15,000' }
                            ]}
                            onChange={(e) => {
                                setMinimumImp(e.value);
                            }}
                            clearIcon={false}
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <Select
                            id="minimun_sheets"
                            label={t('minimumSheets')+" GCP*"}
                            value={minimumImp===0?'':[minimumImp]}
                            options={[ 
                                { value: 2000, label: t('minimumSheets')+' - 2,000' },
                                { value: 2500, label: t('minimumSheets')+' - 2,500' },
                                { value: 3000, label: t('minimumSheets')+' - 3,000' },
                                { value: 4000, label: t('minimumSheets')+' - 4,000' },
                                { value: 5000, label: t('minimumSheets')+' - 5,000' },
                                { value: 6000, label: t('minimumSheets')+' - 6,000' },
                                { value: 7000, label: t('minimumSheets')+' - 7,000' }
                            ]}
                            onChange={(e) => {
                                setMinimumImp(e.value);
                            }}
                            clearIcon={false}
                        />
                    </Col>   
                    )}
                    {series==3?(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('bonusPercentageRL')+" *"}
                            maxLength="3"
                            value={percentage || ''}
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e); }}
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('committedPPIRL')+" *"}
                            maxLength="9"
                            value={percentage || ''}
                            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e)) setPercentage(e); }}
                        />
                        *{"(" + t('valueCaptureNativeFormat') + ")"}
                    </Col>    
                    )}
                </Row>
            );
            
        } else {
            return null;
        };
    };

    // Combine clicks
    const [channelCombineClicks, setChannelCombineClicks] = useState("")
    const [endUserListCombineClicks, setEndUserListCombineClicks] = useState([])
    const [endUserCombineClicks, setEndUserCombineClicks] = useState("")
    const [endUserNameCombine, setEndUserNameCombine] = useState("")
    const [combineClicksList, setCombineClicksList] = useState([])
    // Fetch data
    const fetchEndUsersCombineClicks = (channel) => {
        connectApi
        .get("api/Channels/endUsers",
        {
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListCombineClicksData)
        .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
                );
        });
    };
    const EndUserListCombineClicksData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        setEndUserListCombineClicks(items);
    };

    const showCombineClicks = () => {
        const handleClick = () => {
            let obj = [...combineClicksList];
            obj.push({"channelCombineClicks":channelCombineClicks[0],"endUserCombineClicks":endUserCombineClicks[0],"endUserName":endUserNameCombine});
            setCombineClicksList(obj);
            setChannelCombineClicks("");
            setEndUserCombineClicks("");
            setEndUserListCombineClicks([]);
        };

        const handleClear = () => {
            setCombineClicksList([]);
        }

        if (specialConditionType == 7 || specialConditionType == 8 || specialConditionType == 17){
            return(
                <div>
                <Row>
                    <Col xs="4" md="4">
                        <Select
                        id="channel-list-combine"
                        label={t('channel')}
                        options={channelList}
                        value={channelCombineClicks}
                        placeholder={channelCombineClicks}
                        onChange={(e) => {
                            setChannelCombineClicks([e.value]);
                            setEndUserCombineClicks("");
                            setEndUserListCombineClicks([]);
                            fetchEndUsersCombineClicks(e.value);
                        }}
                        onClear={() => {
                            setChannelCombineClicks("");
                            setEndUserCombineClicks("");
                            setEndUserListCombineClicks([]);
                        }}
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <Select
                            id="end-user-list-combine"
                            label={t('endUser')}
                            options={endUserListCombineClicks}
                            value={endUserCombineClicks}
                            placeholder={endUserCombineClicks}
                            onChange={(e) => {
                                setEndUserNameCombine(e.label);
                                setEndUserCombineClicks([e.value]);
                            }}
                            onClear={() => {
                                setEndUserCombineClicks("");
                            }}
                            />
                    </Col>
                    <Col xs="4" md="4">
                        <Button
                            id="add-combine-clicks"
                            leadingIcon={<IconPlus />}
                            onClick={handleClick}
                        >
                            {t('addCombineClicks')}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="12">
                        <br />
                    <Table
                        name="bonus-table"
                        columns={[
                            {
                                id: "endUserCombineClicks",
                                label: t('endUserId')
                            },
                            {
                                id: "endUserName",
                                label: t('endUser')
                            }
                        ]}
                        data={combineClicksList} />
                    </Col>
                    <Col xs="4" md="4">
                        <br />
                        <Button
                            id="clear-combine-clicks"
                            appearance="secondary"
                            leadingIcon={<IconTrash />}
                            onClick={handleClear}
                        >
                            {t('clearCombineClicks')}
                        </Button>
                    </Col>
                </Row>
                </div>
            );
        } else {
            return null;
        };
    };

    // Minimun Discount
    const [minumimDiscount, setMinumumDiscount] = useState("")

    const showMinumimDiscount = () => {
        if (specialConditionType == 11){
            return(
                <Row>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-discount"
                            label="Minumum Discount %"
                            value={minumimDiscount}
                            maxLength="3"
                            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                            onChange={(e) => { if(!isNaN(e) || e == '-') setMinumumDiscount(e); }}
                        />
                    </Col>
                </Row>
            );
        } else {
            return null;
        };
    };

    const configpress=(status, data)=>{
        if (data.length>0){
            setSeries([4]);
            setSpecialConditionType(0);
            fetchSpConditions(4);
            setOneShotDisabled(!data[0].oneShotVisible);
            setWhiteDisabled(!data[0].whiteVisible);
            setMultiplierConfig(data[0].multiplier);
            setWhiteCpp("");
        } else
            Swal.fire( "Error ", t("Error_S4"), "error" );
    }
    function selectRow(dataArray, checked, id){
        const updatedDataArray = [...dataArray];
        const index = updatedDataArray.findIndex((row) => row.uid === id);
        updatedDataArray[index].rowConfig.selected = checked;
        return updatedDataArray;
    };
    const handleSelect = (event, index) => {
        setPressListBySeriesFilter(selectRow(pressListBySeriesFilter, event.target.checked, index));
        let selectedAnyPress = pressListBySeriesFilter.filter(x => x.rowConfig.selected === true);
        if (selectedAnyPress.length > 0)
            setSelectedPress(true);
        else
            setSelectedPress(false);
    };

    function selectAllPageItems(tableData, checked) {
        return tableData.map((row) => {
            const newRow = row;
            const index = tableData.findIndex((p) => p.uid === newRow.uid);
            if (index > -1) 
                newRow.rowConfig.selected = checked;
            return newRow;
        });
        }
    const handleSelectAll = (event) => {
        setPressListBySeriesFilter(selectAllPageItems(pressListBySeriesFilter, event.target.checked));
        let selectedAnyPress = pressListBySeriesFilter.filter(x => x.rowConfig.selected === true);
        if (selectedAnyPress.length > 0)
            setSelectedPress(true);
        else
            setSelectedPress(false);
    }
    
    const handleSubmit = () => {
        let selectedPressListToUpload = [];
        for (let i = 0; i < pressListBySeriesFilter.length; i++){
            if (pressListBySeriesFilter[i].rowConfig.selected === true) {
                selectedPressListToUpload.push(pressListBySeriesFilter[i].idPress);
            }
        }
        let combineClicksToUpload = [];
        for (let i = 0; i < combineClicksList.length; i++){
            combineClicksToUpload.push(combineClicksList[i].endUserCombineClicks);
        }
        let data = new FormData();
        data.append("idSpecialConditionType",specialConditionType);
        data.append("idEndUser",endUser);
        data.append("idCustomer",channel);
        if(category==1)
            data.append("category",'Special Condition');
        else
            data.append("category",'Ramp up');
        data.append("serie",series);
        data.append("endUserContactName",endUserContactName);
        data.append("endUserContactPhone",endUserContactPhone);
        data.append("endUserContactPosition",endUserContactPosition);
        data.append("startDate",(new Date(startDate).getFullYear() + '-' + (new Date(startDate).getMonth() + 1).toString().padStart(2, '0') + '-01'));
        let endateTrasform = new Date(startDate);
        endateTrasform.setMonth(endateTrasform.getMonth() + (Number(effectiveMonths) + 1));
        endateTrasform.setDate(0);
        let secondTransform = endateTrasform.toISOString().split('T')[0];
        data.append("endDate",secondTransform);
        data.append("effectiveMonths",effectiveMonths);
        if((series >= 4) && (specialConditionType === 21))// si es condicion especial 21 y serie 4 o 5 dividimos por su formato y guardamos en porcentaje
            data.append("percentage",((percentage==''?0:percentage)/multiplierConfig)*100);//multiplicamos por 100 porque en el BackEnd lo divide por 100 para guardarlo
        else {
            if ( specialConditionType === 11 ) // Sie es Minimo Discount enviamos el valor porcentual minimo
                data.append("percentage",minumimDiscount);
            else
                data.append("percentage",percentage==''?0:percentage);
        }
        data.append("minimumImp",minimumImp);
        data.append("justification",justification);
        data.append("competition",competition);
        data.append("volumeGrowth",volumeGrowth);
        data.append("details",details);
        data.append("objetive",objetive);
        data.append("resultFuture",resultFuture);
        data.append("comments",comments);
        data.append("opd",opdNumber);
        data.append("createdBy",endUserEmail);
        data.append("pressList",JSON.stringify(selectedPressListToUpload));
        data.append("compensationTable",JSON.stringify(compensationTable));
        data.append("bonusTable",JSON.stringify(bonusTable));
        data.append("bonusLSDiscountTable",JSON.stringify(bonusLSDiscountSend));
        data.append("combineClicks",JSON.stringify(combineClicksToUpload));
        data.append("minimumPrint",MinimumPrint);
        
        const handleUploadFinal = (status, response) => {
            Swal.fire(
                t('SpConditionSubmitted'),
                "",
                "success"
            );
            resetDefaul();
        }
        
        connectApi.post(
            "api/Channels/UploadSCProcess",
            data,
            handleUploadFinal
        )
        .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
    }

    //View / Render
    return(<> 
        <Container style={{margin: "10px 0"}}>
            <h4 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h4>
            <Row>
                <Col xs="4" md="4">
                    <Select
                        id="category-list"
                        options={[{value: 1, label: 'Special Condition'}, {value: 2, label: 'Ramp up'}]}
                        value={category}
                        placeholder={t('category')}
                        onChange={(e) => {setCategory([e.value]); if(e.value=="1") setOpdNumber("")}}
                        onClear={() => setCategory([])}
                    />
                </Col>
                <Col xs="4" md="4">
                    <Select
                        id="channel-list"
                        label={t('channel')}
                        options={channelList}
                        value={channel}
                        placeholder={t('channel')}
                        onChange={(e) => { setChannel([e.value]); fetchEndUsers(e.value);}}
                        disabled={!category[0]}
                        readOnly={viewChannel}
                    />
                </Col>
                {(category[0] == '2' )?(<>
                    <Col xs="4" md="4">
                        <TextBox
                            id="opd-number"
                            value={opdNumber}
                            label="OPD #"
                            maxLength="14"
                            onKeyPress={(event) => {
                                if (opdNumber.length < 3){
                                    if (!/^[A-Za-z]+$/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                } else {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }
                            }}
                            onChange={(e) => {
                                setOpdNumber(e);
                                if (opdNumber.length == 3){
                                    setOpdNumber(opdNumber + "-")
                                }
                            }}
                        />
                    </Col>
                </>):(<></>)}
            </Row>
            <Row style={{marginTop: "20px"}}>
                <Col xs="4" md="4">
                    <Select
                        id="endUser-list"
                        label={t('endUserName')}
                        options={endUserList}
                        value={endUser}
                        placeholder={t('endUserName')}
                        disabled={channel==""}
                        onChange={(e) => {setEndUser([e.value]); fetchPress(e.value)}}
                    />
                </Col>
                <Col xs="4" md="4">
                    <Select
                        id="Segmento-list"
                        options={[{value: "GCP", label:"Commercial"},{value: "L&P", label:"Labels & Packaging"}]}
                        value={segment}
                        placeholder={t('segmento')}
                        disabled={endUser==""}
                        onChange={(e) => { setSegmentFind(e.value)}}
                        readOnly={segmentFlag}
                    />
                </Col>
                <Col xs="4" md="4">
                    {seriesList.length > 1 ? (
                        <Select
                            id="series-list"
                            label={t("series")}
                            options={seriesList}
                            value={series}
                            placeholder={t("series")}
                            onChange={(e) => { fetchSpConditions(e.value); }}
                        />
                    ):(null)}
                </Col>
            </Row>
        { (Number(series) != 0 && segment != "") ? (
            Number(series) >= 3 ?(<>
                    <Row style={{marginTop: "20px"}}>
                        <Col xs="12" md="12">
                            {pressListBySeriesFilter.length > 0 ? (
                                <Table
                                    name="press-table"
                                    rowSelector="multiSelection"
                                    onSelect={handleSelect}
                                    rowSelectAllState={selectionState(pressListBySeriesFilter)}
                                    onSelectAllPageItems={handleSelectAll}
                                    columns={[
                                        {
                                            id: "uid",
                                            index:"hidden"
                                        },{
                                            id: "idPress",
                                            label: t('press id'),
                                        }, {
                                            id: "classification",
                                            label: t('classification'),
                                        }, {
                                            id: "series",
                                            label: t("series"),
                                        }, {
                                            id: "segment",
                                            label: t('segment'),
                                        }, {
                                            id: "installDate",
                                            label: t('InstallDate'),
                                        }, {
                                            id: "dateEndUser",
                                            label: t('DateEndUser'),
                                        }, {
                                            id: "program",
                                            label: t('Program'),
                                        }
                                    ]}
                                    data={pressListBySeriesFilter} 
                                />
                            ):(null)}<br />
                        </Col>
                    </Row>
                    {selectedPress?(<>
                        <Row>
                            <Col xs="4" md="4">
                                <Select
                                    id="special-condition-type-list"
                                    label={t('Special Condition Type')}
                                    options={specialConditionTypeList}
                                    value={specialConditionType}
                                    onChange={(e) => { setSpecialConditionType([e.value]); }}
                                /><br />
                            </Col>
                        </Row>
                        {specialConditionType?(<>
                            <Container style={{margin: "16px 0"}}>
                                {showFixedBonus()}
                                {showMaxCostPerImpression()}
                                {showBonusSpecialTable()}
                                {showCombineClicks()}
                                {showTiersUp()}
                                {showMinumimDiscount()}
                                {showBonusLSDiscount()}
                                {showRunLength()}
                            </Container>
                            <Row>
                                <Col xs="4" md="4">
                                    <DatePicker
                                        id="stardate-id"
                                        label={t("startdate")}
                                        placeholder="YYYY-MM"
                                        format="YYYY-MM"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e)}
                                        //calendarOrientation={['up']}
                                        monthYearNavigation={true}
                                        blockPastDates={true} 
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="effective-months"
                                        label={t('effMonth')}
                                        maxLength="2"
                                        disabled={!startDate}
                                        onKeyPress={ (event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); } }
                                        onChange={ (e) => { if (e != 0) setEffectiveMonths(e); else setEffectiveMonths(1); }  }
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="12">
                                    <TextArea
                                        id="detalle-id"
                                        label={t('Detalle de la condicion solicitada')}
                                        resize
                                        onChange={(e) => {setDetails(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="objetivo-id"
                                        label={t('Objetivo')}
                                        maxLength="150"
                                        onChange={(e) => {setObjetive(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="12">
                                    <TextArea
                                        id="justification-id"
                                        label={t('Justificacion')}
                                        maxLength="2500"
                                        onChange={(e) => {setJustification(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="volumeG-id"
                                        label={t('Volume Growth')}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        maxLength="9"
                                        onChange={(e) => {setvolumeGrowth(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="12">
                                    <TextArea
                                        id="competition-id"
                                        label={t('Competencia')}
                                        maxLength="2500"
                                        onChange={(e) => {setCompetition(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="12">
                                    <TextArea
                                        id="resultado-id"
                                        label={t('Resultado esperado con la condicion')}
                                        maxLength="2500"
                                        onChange={(e) => {setResultFuture(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="12">
                                    <TextArea
                                        id="comentarios-id"
                                        label={t('comments')}
                                        maxLength="2500"
                                        onChange={(e) => {setComments(e)}}
                                    /><br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="contact-name"
                                        label={t('contactName')}
                                        maxLength = "100"
                                        onChange={(e) => {setEndUserContactName(e)}}
                                        required
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="contact-phone"
                                        label={t('phone')}
                                        maxLength="20"
                                        onChange={(e) => {setEndUserContactPhone(e)}}
                                        required
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="contact-position"
                                        label={t('jobPosition')}
                                        maxLength="100"
                                        onChange={(e) => {setEndUserContactPosition(e)}}
                                        required
                                    /><br />
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '16px' }}>
                                <Col xs="12" md="6">
                                    <Button
                                        style={{ marginRight: '16px' }}
                                        disabled={false}
                                        title={t('Send Data')}
                                        onClick={handleSubmit}
                                    >
                                        {t('Send')}
                                    </Button>
                                </Col>
                                <Col xs="12" md="6">
                                    <Button
                                        id="clear-button"
                                        style={{ marginLeft:"15px" }}
                                        appearance="secondary"
                                        onClick={() => resetDefaul()}>
                                            {t('Clear')}
                                    </Button>
                                </Col>
                            </Row>
                        </>):(<></>)}
                    </>):(<></>)}
                </>) : (<><br /><h5>Las condiciones especiales solo son para serie 3 en adelante...</h5></>)
            ):(null) }
        </Container>
    </>);
}

export default NewSpecialConditionsProcess;